import { useEffect, useState } from 'react'

import { commonIcons } from '@apps-common/config/icons'
import { sortNumerically } from '@apps-common/helpers/array-sort'
import { IUnitTrafficModel } from '@apps-common/types/portal/unit'

interface IEventSignalStrengthStats {
  avg?: string
  low?: string
  high?: string
}

interface IProps {
  loading?: boolean
  noIcon?: boolean
  data?: IUnitTrafficModel[]
}

export const SignalStrengthKpi: React.FC<IProps> = ({ loading, noIcon, data }) => {
  const [stats, setStats] = useState<IEventSignalStrengthStats>({ avg: undefined, low: undefined, high: undefined })

  const buildSignalStrengthStats = () => {
    if (!data) {
      return { avg: undefined, low: undefined, high: undefined }
    }

    const strengths = data.map((s) => parseInt(s.signalStrength, 10)).filter((s) => !Number.isNaN(s))

    const avg = Math.ceil(strengths.reduce((acc, curr) => acc + curr, 0) / strengths.length / 3)
    const low = Math.ceil(strengths.sort((a, b) => sortNumerically(a, b))[0] / 3)
    const high = Math.ceil(strengths.sort((a, b) => sortNumerically(b, a))[0] / 3)

    return {
      avg: Number.isNaN(avg) ? '-' : avg.toString(),
      low: Number.isNaN(low) ? '-' : low.toString(),
      high: Number.isNaN(high) ? '-' : high.toString()
    }
  }

  useEffect(() => {
    const sData = buildSignalStrengthStats()

    setStats(sData)
  }, [data])

  return (
    <div className='flex items-center justify-center gap-[5px] text-[0.9rem] bg-secondary-content/10 p-[3px] rounded-full'>
      {!noIcon && (
        <div className='p-[5px] w-[30px] h-[30px] rounded-full'>
          <commonIcons.cellTowerSignal className='text-[1.2rem] text-text-muted' />
        </div>
      )}
      <div className='flex items-center justify-center gap-[5px] pr-[8px] rounded-full bg-warning text-on-warning text-[0.8rem]'>
        <div className='w-[30px] h-[30px] bg-on-warning/20 rounded-full flex items-center justify-center'>{stats?.low || '-'}</div>
        low
      </div>

      <div className='flex items-center justify-center gap-[5px] pr-[8px] rounded-full bg-info text-on-info text-[0.8rem]'>
        <div className='w-[30px] h-[30px] bg-on-info/20 rounded-full flex items-center justify-center'>{stats?.avg || '-'}</div>
        avg
      </div>

      <div className='flex items-center justify-center gap-[5px] pr-[8px] rounded-full bg-success text-on-success text-[0.8rem]'>
        <div className='w-[30px] h-[30px] bg-on-success/20 rounded-full flex items-center justify-center'>{stats?.high || '-'}</div>
        high
      </div>
    </div>
  )
}
